var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DB1AE296-C88C-45DE-90F7-3573391755A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-3e",
    transform: "translate(-388.000000, -345.000000)",
    fill: "#444444",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(368.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(20.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-box",
    transform: "translate(0.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "address-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99747155,4.06527262 C5.28770265,4.06527262 3.89663122,5.45634405 3.89663122,7.16611296 C3.89663122,8.87588186 5.28770265,10.2669533 6.99747155,10.2669533 C8.70724046,10.2669533 10.0983119,8.87588186 10.0983119,7.16611296 C10.0983119,5.45634405 8.70724046,4.06527262 6.99747155,4.06527262 Z M6.99747155,9.57787766 C5.66759147,9.57787766 4.58570685,8.49599305 4.58570685,7.16611296 C4.58570685,5.83623287 5.66759147,4.75434825 6.99747155,4.75434825 C8.32735164,4.75434825 9.40923626,5.83623287 9.40923626,7.16611296 C9.40923626,8.49599305 8.32735164,9.57787766 6.99747155,9.57787766 Z",
    id: "Shape",
    stroke: "#444444",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99747155,0.737541528 C3.45274283,0.737541528 0.568900126,3.66644427 0.568900126,7.26655939 C0.568900126,8.73598078 1.03829401,10.1236586 1.92660103,11.2797081 L6.99747155,17.8803987 L12.0683421,11.2795773 C12.9566491,10.1236586 13.426043,8.73598078 13.426043,7.26655939 C13.426043,3.66644427 10.5422003,0.737541528 6.99747155,0.737541528 Z M11.2885945,10.6617272 L6.99747155,16.2474903 L2.70634863,10.6617272 C1.95506084,9.68394395 1.55791112,8.50997632 1.55791112,7.26655939 C1.55791112,4.22033833 3.99811543,1.74200581 6.99747155,1.74200581 C9.99682768,1.74200581 12.437032,4.22033833 12.437032,7.26655939 C12.437032,8.50997632 12.0398823,9.68394395 11.2885945,10.6617272 Z",
    id: "Shape"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.5f197d49af548f49ba15431fdab8dca6.svg";
export { ForwardRef as ReactComponent };